export default __webpack_public_path__ + "static/media/place-holder-image.a59d7730.jpg";